export { BASE_API_URL, REQUEST_METHODS, endpoints } from './api';

export const MAX_COOKIES_AGE = 3600 * 24;
export const ACCESS_TOKEN_AGE = 60 * 5;
export const REFRESH_TOKEN_AGE = 3600 * 24 * 7;

export const ADMIN_TOKEN_COOKIE_NAME = '_atk';
export const ADMIN_REFRESH_TOKEN_COOKIE_NAME = '_artk';
